<div class="mpc-dialog">
  <div class="mpc-dialog-header d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
    <div class="mpc-dialog-title">Mountpoint Connection Setup</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="mpc-dialog-body">
    <app-external-mountpoint-connections [hideTitle]="true"></app-external-mountpoint-connections>
  </div>
</div>


